import { PlanBase } from "@syla/shared/types/models/PlanBase";
import { SubscriptionWithPlansAndAccess } from "@syla/shared/types/responses/GetSubscriptionsResponse";
import React, { Fragment } from "react";
import { canManageExistingSubscription } from "../../../helper/permissions";
import { useCurrentAccountStore } from "../../../store/currentAccountStore";
import { PlanRenewalDate } from "./PlanRenewalDate";
import { SubscriptionAlert } from "./SubscriptionAlert";
import { SubscriptionPlanDetails } from "./SubscriptionPlanDetails";
import { TransactionCap } from "./TransactionCap";
import { useSubscriptionActions } from "./useSubscriptionActions";

export const SubscriptionDetails = ({
  subscription,
  downgradePlan,
  isRedirecting,
  setIsRedirecting,
}: {
  subscription?: SubscriptionWithPlansAndAccess<string>;
  downgradePlan: PlanBase<string> | undefined;
  isRedirecting: boolean;
  setIsRedirecting: (value: boolean) => void;
}) => {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const { openMainPortal } = useSubscriptionActions({
    currentSub: subscription,
    accountId,
    setIsRedirecting,
  });

  const canManageSubscription =
    !!subscription &&
    !!subscription.stripeSubscriptionId &&
    canManageExistingSubscription({
      subscriptions: [subscription],
    });

  return (
    <>
      <SubscriptionAlert
        canManageSubscription={canManageSubscription}
        subscription={subscription}
        downgradePlan={downgradePlan}
        isRedirecting={isRedirecting}
        onManageBillingAction={openMainPortal}
      />
      <SubscriptionPlanDetails
        accountId={accountId}
        canManageSubscription={canManageSubscription}
        subscription={subscription}
      />
      <PlanRenewalDate subscription={subscription} />
      <TransactionCap subscription={subscription} />
    </>
  );
};
